import { render, staticRenderFns } from "./SupplierItems.vue?vue&type=template&id=77266500&scoped=true"
import script from "./SupplierItems.vue?vue&type=script&lang=js"
export * from "./SupplierItems.vue?vue&type=script&lang=js"
import style0 from "./SupplierItems.vue?vue&type=style&index=0&id=77266500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77266500",
  null
  
)

export default component.exports